import { Box, Text } from '@factorialco/deprecated-design-system'
import { DetailsItemsList, Tabs } from '@factorialco/factorial-one-react/dist/experimental'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { DEFAULT_COLUMN_VALUE } from 'modules/universal_importer/components/ImportProcessDataCollection'

interface ImportProcessErrorModalProps {
  isOpen: boolean
  onClose: () => void
  selectedRowErrors: string
  selectedRowColumns: Record<string, string>
}

export const ImportProcessErrorModal: React.FC<ImportProcessErrorModalProps> = ({
  isOpen,
  onClose,
  selectedRowErrors,
  selectedRowColumns,
}) => {
  return (
    <Sidepanel
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
      open={isOpen}
      width="wide"
      boxPadding={undefined}
    >
      <Box paddingBottom="s16" paddingLeft="s20">
        <Text.Header1 weight="semibold">{selectedRowErrors}</Text.Header1>
      </Box>
      <Tabs
        tabs={[
          {
            index: true,
            label: i18n.t('universal_importer.import_history_process.error_modal.tabs.columns'),
          },
        ]}
      />
      <Box paddingY="s16" paddingLeft="s20">
        <DetailsItemsList
          title=""
          details={Object.entries(selectedRowColumns).map(([key, value]) => ({
            title: key,
            content: {
              type: 'item',
              text: value,
              action: value !== DEFAULT_COLUMN_VALUE ? { type: 'copy' } : undefined,
            },
          }))}
        />
      </Box>
    </Sidepanel>
  )
}
